import React from 'react';
import { Modal } from 'react-bootstrap';
import TripCommentBox from '../../comments/TripCommentBox';
import { useTripModal } from '../../contexts/modal-context-trip';
import { useTrip } from '../../contexts/trip-context';

interface ActivityCommentModalProps {
  show: boolean;
  handleClose: () => void;
}

const ActivityCommentModal: React.FC<ActivityCommentModalProps> = ({
  show,
  handleClose
}) => {
  const { getActivityData } = useTripModal();
  const { trip } = useTrip();
  const activityData = getActivityData();

  if (!activityData || !trip?.id) {
    return null;
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size='lg'
      centered
    >
      <Modal.Body style={{ padding: '0' }}>
        <TripCommentBox
          tripId={trip.id}
          entityType='activity'
          entityId={activityData.id}
          initialCollapsed={false}
          title={activityData.title}
          onClose={handleClose}
          showBorder={false}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ActivityCommentModal;
